import { Browser } from "@phosphor-icons/react";

import { KINDS } from "./kinds";

export function DeviceIcon({ kind }: { kind: string }) {
  const Icon = KINDS[kind] ?? Browser;
  return <Icon weight="duotone" className="h-5 w-5" />;
}
